import NavMenuBar from '@ui/nav-menu-bar/NavMenuBar'
import React, {HTMLAttributes, useCallback} from 'react'
import {
  agencyAdminList,
  candidateList,
  companyAdminList,
  generalAdminList,
  mainAgencyAdminList,
  mspAgencyList,
  platformAdminList,
} from './MenuItems'
import S from './styles/LayoutStyles'

interface ILayout extends HTMLAttributes<unknown> {
  children: React.ReactNode
  variant: 'platform' | 'msp' | 'main-agency' | 'agency' | 'company' | 'general-admin' | 'candidate'
}

export default function Layout({children, variant}: ILayout): JSX.Element {
  const getNavItems = useCallback(() => {
    switch (variant) {
      case 'platform':
        return platformAdminList
      case 'msp':
        return mspAgencyList
      case 'main-agency':
        return mainAgencyAdminList
      case 'general-admin':
        return generalAdminList
      case 'agency':
        return agencyAdminList
      case 'company':
        return companyAdminList
      case 'candidate':
        return candidateList
      default:
        return null
    }
  }, [variant])

  const items = getNavItems()

  if (!items) {
    return null
  }

  return (
    <S.Container data-testid="layout-container">
      <S.Main data-testid="layout-main">
        <NavMenuBar items={items} variant={variant} />
        {children}
      </S.Main>
    </S.Container>
  )
}
